import React from 'react';
import {
	Table,
	TableHead,
	TableHeadRow,
	TableHeadCell,
	TableBody,
	TableRow,
	TableCell,
} from './table';
import { totaal_titels } from '../lib/historicalData';

export default function TotaalTitels() {
	return (
		<div className="overflow-x-auto">
			<Table className="table-auto overflow-scroll w-full">
				<TableHead>
					<TableHeadRow>
						<TableHeadCell>Club</TableHeadCell>
						<TableHeadCell>Aantal titels</TableHeadCell>
					</TableHeadRow>
				</TableHead>
				<TableBody className="bg-white divide-y divide-gray-200">
					{totaal_titels.map((seizoen, i) => (
						<TableRow key={i} striped>
							<TableCell>{seizoen.Club}</TableCell>
							<TableCell>{seizoen['Aantal Titels']}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
